import React from "react";
import _ from "lodash";
import { Div, Image, Text, StyleReset } from "atomize";
import { Link } from "gatsby";
import CustomContainer from "../common/CustomContainer";
import WebsiteContainer from "../common/WebsiteContainer";
import Swiper from "react-id-swiper";
import SolvedModal from "../../modals/SolvedModal";
import ImageLink from "./ImageLink";

const params = {
  slidesPerView: 5.4,
  spaceBetween: 15,
  autoHeight: true,
  mousewheel: {
    forceToAxis: true,
    invert: true,
  },
  slidesOffsetAfter: 60,
  breakpoints: {
    1920: {
      slidesPerView: 6.4,
      spaceBetween: 20,
      slidesOffsetAfter: 60,
    },
    1200: {
      slidesPerView: 5.4,
      spaceBetween: 16,
      slidesOffsetAfter: 60,
    },
    1024: {
      slidesPerView: 5.4,
      spaceBetween: 16,
      slidesOffsetAfter: 60,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 16,
      slidesOffsetAfter: 60,
    },
    640: {
      slidesPerView: 1.5,
      spaceBetween: 16,
      slidesOffsetAfter: 30,
    },
    320: {
      slidesPerView: 1.5,
      spaceBetween: 16,
      slidesOffsetAfter: 30,
    },
  },
};

class SolvedSlider extends React.Component {
  state = { showModal: false };
  render() {
    const { showModal, swiperIndex } = this.state;
    const { items } = this.props;
    return (
      <Div className="solved-swiper">
        <Swiper {...params}>
          {items.map((item, index) => {
            return (
              <div
                className="card-animation"
                onClick={() =>
                  this.setState({ showModal: true, swiperIndex: index })
                }
              >
                <Div
                  bg={{ xs: "#131313", md: "white" }}
                  d="flex"
                  flexDir="column"
                  h="100%"
                  cursor="pointer"
                >
                  <ImageLink link="">
                    <Div
                      bgImg={_.get(item, "image.file.url")}
                      bgSize="cover"
                      bgPos="center"
                      p={{ b: "56.3%" }}
                      pos="relative"
                    >
                      <Div
                        pos="absolute"
                        top="0"
                        left="0"
                        w="100%"
                        h="100%"
                        bg="rgba(0, 0, 0, 0.46)"
                        d="flex"
                        align="center"
                        justify="center"
                      >
                        <Image
                          src="../../images/solved-badge.svg"
                          h="1.625rem"
                          transform="rotate(-5deg)"
                        />
                      </Div>
                    </Div>
                  </ImageLink>
                  <Div p="0.75rem 1rem 1rem 0.75rem">
                    <Text
                      textSize="caption2"
                      textColor={{ xs: "white", md: "black" }}
                      style={{ lineHeight: "18px" }}
                    >
                      {item.title}
                    </Text>
                  </Div>
                </Div>
              </div>
            );
          })}
        </Swiper>
        <SolvedModal
          isOpen={showModal}
          onClose={() => this.setState({ showModal: false })}
          items={items}
          swiperIndex={swiperIndex}
        />
      </Div>
    );
  }
}

export default SolvedSlider;
